export const TEST_ID_ACTION_WITH_CONFIRMATION_CONFIRM_BUTTON =
  'ACTION-WITH-CONFIRMATION-CONFIRM-BUTTON';
